import { useQuery } from "@tanstack/react-query"

import { useStaticDataContext } from "modules/PsyProfile/common/StaticDataContext"
import { getRelatedPsys } from "modules/PsyProfile/common/api"
import { PsySnippet } from "modules/PsyProfile/components/FAQContainer/components/PsySnippet"
import { Competence } from "utils/interfaces"

export function SimilarPsys({
    competences,
    identity,
}: {
    competences: Competence[]
    identity: string
}) {
    let { similar } = useStaticDataContext()
    const enableQuery = similar.length == 0
    const query = useQuery(
        ["related-psys", identity],
        () => getRelatedPsys(competences.map((c) => c.id)),
        {
            enabled: enableQuery,
        }
    )
    if (enableQuery) {
        similar = query.data?.profiles ?? []
    }
    return {
        title: <>Другие психологи по&nbsp;этой специализации</>,
        content: (
            <>
                {similar.map((psy) => (
                    <PsySnippet key={psy.hash_id} psy={psy} />
                ))}
            </>
        ),
    }
}
